

import React, { createElement } from 'react';
import getStyle, { getAfterStyle } from './style';
import { getConfiguration } from '../../config';
import ScreenClassResolver from '../../context/ScreenClassResolver';
import { Div, Span } from '../../primitives';













const Container = ({
  children,
  fluid = false,
  xs = false,
  sm = false,
  md = false,
  lg = false,
  xl = false,
  xxl = false,
  style = {},
  component = Div,
  ...otherProps
}) =>
<ScreenClassResolver>
    {(screenClass) => createElement(
    component,
    {
      style: getStyle({
        fluid,
        xs,
        sm,
        md,
        lg,
        xl,
        xxl,
        screenClass,
        containerWidths: getConfiguration().containerWidths,
        gutterWidth: getConfiguration().gutterWidth,
        moreStyle: style
      }),
      ...otherProps
    },
    <>
        {children}
        <Span style={getAfterStyle()} />
      </>
  )}
  </ScreenClassResolver>;


export default Container;